import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { BulkActionEntityConfig } from 'modules/BulkActions/types'
import {
  bulkActionTitle,
  downloadZipTitle
} from 'modules/BulkActions/bulkActionTitle'

/**
 * Counts-only: there's no quotes-by-ids enrichment endpoint, so the in-flight
 * panel shows a summary ("N archived, M failed") with no per-quote review rows.
 */
export const quoteBulkActionConfig: BulkActionEntityConfig = {
  listTitle: 'Quote',
  invalidateOnProgress: dashboard20240730Client.postArchiveMultipleQuotes,
  titles: {
    ARCHIVE_QUOTES: bulkActionTitle({
      verbing: 'Archiving',
      past: 'archived',
      verb: 'archive',
      noun: 'quote'
    }),
    DOWNLOAD_QUOTES: downloadZipTitle(
      bulkActionTitle({
        verbing: 'Downloading',
        past: 'downloaded',
        verb: 'download',
        noun: 'quote'
      })
    )
  },
  downloadZip: {
    types: ['DOWNLOAD_QUOTES'],
    fetch: dashboard20240730Client.getQuoteBulkDownloadZip,
    filename: bulkActionId => `quotes-${bulkActionId}.zip`,
    errorMessage: 'Unable to download quotes zip'
  }
}
